import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './css/HeroSection.css';
import bannerImg from '../Assets/Image/heroseciton.webp';
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultHeroContent = {
  subtitle: 'Distinguished Professional Services',
  headlineLine1: 'NAVIGATING COMPLEXITY',
  headlineLine2: 'WITH CONFIDENCE',
  description:
    'Whales Advisory simplifies complex legal and regulatory frameworks to guide start-ups, SMEs, and large corporates through the Egyptian market. Leveraging deep local expertise and strong governmental relationships, we enable businesses to establish, operate, and expand with efficiency and absolute loyalty to their interests.',
  subtitleFontSize: 16,
  headlineFontSize: 85,
  descriptionFontSize: 18,
};

// Reusable Playfair Display typewriter text
const TypewriterText = ({
  text,
  as: Tag = 'span',
  className = '',
  startDelay = 0,
  step = 0.05,
}) => {
  const Container = motion(Tag);

  return (
    <Container
      className={className}
      initial="hidden"
      animate="visible"
      variants={{
        hidden: { opacity: 1 },
        visible: {
          opacity: 1,
          transition: {
            delayChildren: startDelay,
            staggerChildren: step,
          },
        },
      }}
    >
      {text.split('').map((ch, index) => (
        <motion.span
          key={index}
          variants={{
            hidden: { opacity: 0, y: 2 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          {ch === ' ' ? '\u00A0' : ch}
        </motion.span>
      ))}
    </Container>
  );
};

const HeroSection = () => {
  const [hero, setHero] = useState(defaultHeroContent);

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/hero`);
        setHero((current) => ({ ...current, ...response.data }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchHero();
  }, []);

  return (
    <motion.div
      className="hero-wrapper"
      style={{
        backgroundImage: `url(${bannerImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <header className="hero-content">
        <div className="hero-overlay"></div>
        <div className="container text-left">
          {/* Typewriter subtitle */}
          <TypewriterText
            as="p"
            className="subtitle"
            text={hero.subtitle}
            startDelay={0.2}
            step={0.04}
            style={{ fontSize: `${hero.subtitleFontSize}px` }}
          />

          {/* Typewriter main headline, line by line */}
          <h1
            className="main-title"
            style={{ fontSize: `${hero.headlineFontSize}px` }}
          >
            <TypewriterText
              text={hero.headlineLine1}
              startDelay={0.8}
              step={0.06}
            />
            <br />
            <TypewriterText
              text={hero.headlineLine2}
              startDelay={1.4}
              step={0.06}
            />
          </h1>

          <p
            className="description"
            style={{ fontSize: `${hero.descriptionFontSize}px` }}
          >
            {hero.description}
          </p>
        </div>

        {/* Geometric Accents */}
        <div className="geometric-bg">
          <div className="triangle-purple"></div>
          <div className="triangle-blue"></div>
        </div>
      </header>
    </motion.div>
  );
};

export default HeroSection;
